import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDealById } from '@services/deal.service';
import { IDeal } from '@interfaces/deal';

export const fetchDealDetail = createAsyncThunk('voucher/getDealById', async (dealId: string) => {
	return await getDealById(dealId);
});

export interface DealDetailState {
	deal: IDeal;
	isLoading: boolean;
}

const initialState = {
	deal: {
		_id: '',
		isFlash: false,
		totalQuantity: 0,
		purchaseLimitPerUser: 0,
		outletsDetail: '',
	},
	isLoading: true,
} satisfies DealDetailState as DealDetailState;

const dealDetailSlice = createSlice({
	name: 'dealDetail',
	initialState: initialState,
	reducers: {
		fetchDealDetail: (state, action: PayloadAction<DealDetailState>) => {
			return {
				...state.deal,
				...action.payload,
			};
		},
	},
	extraReducers(builder) {
		builder.addCase(fetchDealDetail.pending, (state: DealDetailState) => {
			state.isLoading = true;
		});
		builder.addCase(fetchDealDetail.fulfilled, (state: DealDetailState, action) => {
			state.deal = (action.payload as any)['data'] ?? [];
			state.isLoading = false;
		});
		builder.addCase(fetchDealDetail.rejected, (state: DealDetailState) => {
			state.isLoading = false;
		});
	},
});

export const dealDetailReducer = dealDetailSlice.reducer;
export default dealDetailSlice;
